import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null })
    window.location.href = '/'
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '20px' }}>
          <div style={{ maxWidth: '500px', width: '100%', padding: '20px', border: '1px solid #ccc' }}>
            <h1>Something went wrong</h1>
            <p>We encountered an unexpected error. Please try refreshing the page or returning to the home page.</p>
            {this.state.error && (
              <div style={{ padding: '10px', marginTop: '10px', backgroundColor: '#f5f5f5' }}>
                <p style={{ fontSize: '12px', fontFamily: 'monospace' }}>{this.state.error.message}</p>
              </div>
            )}
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => window.location.reload()}>Refresh Page</button>
              <button onClick={this.handleReset}>Go Home</button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
